import { apiGet, apiPost } from '../config/api';

export const getMessages = (user, page = 1) =>
  apiGet(`/student-portal/chat?page=${page}&limit=50`, user);

export const sendMessage = (user, content) =>
  apiPost('/student-portal/chat', user, { content });
